module.exports = __webpack_public_path__ + "img/banner2.f625759.png";